var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"main-content-card",attrs:{"flat":""}},[_c('v-card-text',[_c('h2',{staticClass:"subheading"},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":"red"}},[_vm._v("lock")]),_vm._v("无权限访问该页面！")],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d366d32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/403.vue
// module id = null
// module chunks = 